import { useState, useEffect, Fragment } from 'react'

function RecordHeader({ record, recordType, isSelected, isExpanded, onToggle, onSelect, onCopy }) {
    try {
        // Format date
        const formattedDate = new Date(record.create_time).toLocaleString('zh-TW', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
        
        // Extract YouTube video title or use a default title
        const getRecordTitle = () => {
            if (record.type === 'youtube_to_text') {
                // Try to extract video ID from URL for display purposes
                let videoId = '';
                try {
                    if (record.source.includes('youtube.com/watch?v=')) {
                        const urlParams = new URLSearchParams(new URL(record.source).search);
                        videoId = urlParams.get('v') || '';
                    } else if (record.source.includes('youtu.be/')) {
                        videoId = record.source.split('youtu.be/')[1].split('?')[0];
                    }
                    
                    if (videoId) {
                        return `${record.content?.split('\n')[0]?.substring(0, 150)} (ID: ${videoId})`;
                    }
                } catch (e) {
                    console.error('Error parsing YouTube URL:', e);
                }
            } else if (record.type == 'pdf_to_excel') {
                return record.title ? record.title : '未知';
            } else if (record.type == 'website_scraper') {
                return record.title ? record.title : record.content?.split('\n')[0]?.substring(0, 50);
            }
            
            // Default title extraction logic
            return record.content?.split('\n')[0]?.substring(0, 50) || '未命名記錄';
        };

        return (
            <div className="flex items-center p-4" data-name="record-header">
                <div className="mr-3">
                    <input 
                        type="checkbox"
                        checked={isSelected}
                        onChange={onSelect}
                        className="w-5 h-5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                        data-name="record-checkbox"
                    />
                </div>
                <div 
                    className="flex-grow flex items-center justify-between cursor-pointer"
                    onClick={onToggle}
                >
                    <div className="flex items-center space-x-3">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                            record.type === 'youtube_to_text' ? 'bg-red-100 text-red-500' : record.type === 'pdf_to_excel' ? 'bg-green-100 text-green-500' : 'bg-indigo-100 text-white'
                        }`}>
                            <i className={`${record.type === 'youtube_to_text' ? 'fab fa-youtube' : record.type === 'pdf_to_excel' ? 'fas fa-file-pdf' : 'fas fa-globe'}`}></i>
                        </div>
                        <div>
                            <h3 className="font-medium line-clamp-1" data-name="record-title">
                                {getRecordTitle()}
                            </h3>
                            <div className="flex items-center text-sm text-gray-500">
                                <span className="mr-3" data-name="record-date">{formattedDate}</span>
                                <span className="px-2 py-0.5 rounded-full text-xs bg-gray-100" data-name="record-type">
                                    {(() => {
                                        const typeMap = {
                                            'youtube_to_text': 'YouTube 轉文字',
                                            'website_scraper': '網站內容擷取',
                                            'pdf_to_excel': 'PDF 轉 Excel'
                                        };
                                        return typeMap[record.type] || '未知類型';
                                    })()}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center">
                        { record.type != 'pdf_to_excel' ? <button 
                            onClick={(e) => {
                                e.stopPropagation();
                                onCopy(record.content);
                            }}
                            className="p-2 text-gray-500 hover:text-gray-700 mr-2"
                            title="複製內容"
                            data-name="copy-button"
                        >
                            <i className="fas fa-copy"></i>
                        </button> : <></> }
                        <i className={`fas fa-chevron-down transition-transform ${isExpanded ? 'rotate-180' : ''}`}></i>
                    </div>
                </div>
            </div>
        );
    } catch (error) {
        console.error('RecordHeader component error:', error);
        reportError(error);
        return null;
    }
}

export default RecordHeader;